
import React from 'react';

const BrandSwitcher = () => {
  const brands = [
    { 
      name: "JUV Medspa", 
      url: "https://juv.bespokeveneers.com",
      current: true 
    },
    { 
      name: "Bespoke Veneers", 
      url: "https://bespokeveneers.com" 
    },
    { 
      name: "Full Arch Implants", 
      url: "https://bespokeveneers.com/full-arch-implants" 
    }
  ];

  const handleBrandClick = (url: string, current: boolean) => {
    if (!current) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className="bg-black text-white py-2 px-6 fixed top-0 left-0 right-0 z-50">
      <div className="container mx-auto max-w-7xl">
        <nav className="flex items-center justify-center space-x-8">
          {brands.map((brand) => (
            <button
              key={brand.name}
              onClick={() => handleBrandClick(brand.url, brand.current || false)}
              className={`
                text-sm font-light tracking-wide transition-all duration-300
                ${brand.current 
                  ? 'text-white opacity-100' 
                  : 'text-white/80 hover:text-white hover:opacity-100'
                }
                relative after:content-[''] after:absolute after:bottom-0 after:left-0 
                after:w-0 after:h-px after:bg-white after:transition-all after:duration-300
                hover:after:w-full
              `}
              disabled={brand.current}
            >
              {brand.name}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default BrandSwitcher;
